
import GDPRCheck from './GDPRCheck.vue'
export default {
  props: {
    labels: {
      type: Object,
      required: true,
      default: () => {}
    },
    data: {
      type: Object,
      required: true,
      default: () => {}
    },
    noCheckbox: {
      type: Boolean,
      default: false
    },
    insideModal: {
      type: Boolean,
      default: false
    },
    hideOptional: {
      type: Boolean,
      default: false
    },
    fieldError: {
      type: String,
      default: ''
    },
    isLogged: {
      type: Boolean,
      default: false
    },
    font: {
      type: String,
      default: ''
    },
    openLinksInNewTab: {
      type: Boolean,
      default: false
    }
  },
  components: {
    GDPRCheck
  }
}
